import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { getInfo } from "./getInfoSlice";
import { FaUserAlt } from "react-icons/fa";
import { MdAlbum } from "react-icons/md";
import { IoMdAlbums } from "react-icons/io";
import { RiMoneyEuroBoxFill } from "react-icons/ri";
import { GiTakeMyMoney } from "react-icons/gi";
import { BsFilePost } from "react-icons/bs";

const useStyles = makeStyles({
  smallBox: {
    display: "block",
    marginBottom: "20px",
    position: "relative",
    textDecoration: "none",

    "&:hover": {
      textDecoration: "none",

      "& svg": {
        fontSize: "5rem",
      },
    },

    "& h3": {
      fontSize: "44px",
      fontWeight: "700",
      margin: "0 0 1rem 0",
      padding: "10px 0 0 10px",
      whiteSpace: "nowrap",
      color: "#fff",
    },

    "& p": {
      fontSize: "24px",
      color: "#fff",
      fontWeight: 400,
      padding: "25px 0 0 10px"
    },
  },
  innerBox: {
    borderRadius: "5px",
    boxShadow: "0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2)",
    transition: "all 0.2s linear",
    height: "200px !important",
    "@media only screen and (max-width: 86em)": {
    height: "9rem",
    },

    "&:hover": {
      filter: "brightness(0.8)",
    },
  },
  icon: {
    color: "rgba(0, 0, 0, 0.15)",
    zIndex: 0,

    "& svg": {
      fontSize: "4rem",
      position: "absolute",
      right: "40px",
      top: "30px",
      transition: "all 0.2s linear",
    },
  },

  inner: {
    padding: "1.2rem",
  },

  container: {
    padding: "1rem 1rem 1rem 17rem",
    margin: "4rem 0 0 0",
    width: "100%",
  },
  containerBox: {
    width: "350px",
    marginLeft: "25px"
  }
});

const Info = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const info = useSelector((state) => state.info);

  useEffect(() => {
    dispatch(getInfo());
    // eslint-disable-next-line
  }, [...Object.values(info)]);

  return (
    <>
      <div className={classes.containerBox}>
        <Link to="/allArtist" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#F59D4A">
            <div className={classes.inner}>
              <h3>{info.totalArtists}</h3>
              <p>Total Registered Artists</p>
            </div>
            <div className={classes.icon}>
              <FaUserAlt />
            </div>
          </Box>
        </Link>
      </div>

      <div className={classes.containerBox}>
        <Link to="/songs" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#3C7093">
            <div className={classes.inner}>
              <h3>{info.totalSongs}</h3>
              <p>Total Songs Uploaded</p>
            </div>
            <div className={classes.icon}>
              <MdAlbum />
            </div>
          </Box>
        </Link>
      </div>

      <div className={classes.containerBox}>
        <Link to="/albums" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#4EAFA4">
            <div className={classes.inner}>
              <h3>{info.totalAlbums}</h3>
              <p>Total Albums Uploaded</p>
            </div>
            <div className={classes.icon}>
              <IoMdAlbums />
            </div>
          </Box>
        </Link>
      </div>

      <div className={classes.containerBox}>
        <Link to="/financePayment" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#7BB8D8">
            <div className={classes.inner}>
              <h3>€{info.totalPaymentCollected}</h3>
              <p>Total Payments Collected</p>
            </div>
            <div className={classes.icon}>
              <RiMoneyEuroBoxFill />
            </div>
          </Box>
        </Link>
      </div>

      <div className={classes.containerBox}>
        <Link to="/financePayment" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#E7717D">
            <div className={classes.inner}>
              <h3>€{info.totalArtistPayment}</h3>
              <p>Total Payments To Artist</p>
            </div>
            <div className={classes.icon}>
              <RiMoneyEuroBoxFill />
            </div>
          </Box>
        </Link>
      </div>

      <div className={classes.containerBox}>
        <Link to="/financePayment" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#5CDB95">
            <div className={classes.inner}>
              <h3>€{info.totalPlactronPayment}</h3>
              <p>Total Payments To Plactron</p>
            </div>
            <div className={classes.icon}>
              <RiMoneyEuroBoxFill />
            </div>
          </Box>
        </Link>
      </div>

      <div className={classes.containerBox}>
        <Link to="/allArtist" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#F2C83B">
            <div className={classes.inner}>
              <h3>{info.totalSubscription}</h3>
              <p>Total Subscribers</p>
            </div>
            <div className={classes.icon}>
              <GiTakeMyMoney />
            </div>
          </Box>
        </Link>
      </div>

      <div className={classes.containerBox}>
        <Link to="/postControl" className={classes.smallBox}>
          <Box className={classes.innerBox} bgcolor="#563D7C">
            <div className={classes.inner}>
              <h3>{info.totalPosts}</h3>
              <p>Total Posts</p>
            </div>
            <div className={classes.icon}>
              <BsFilePost />
            </div>
          </Box>
        </Link>
      </div>
    </>
  );
};

export default Info;
